import { Area } from '../../interfaces/areas';
import { areas } from '../../api/areas';

async function fetchAreas(): Promise<Area[]> {
	try {
		return await areas.getAreas();
	} catch (error) {
		throw error;
	}
}

export const areaService = {
	fetchAreas,
};
